import { useTranslate } from '@tolgee/react'
import { TurnoverDto } from '@tom-ui/integration'
import { OptionsButton } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'

interface Props {
  turnoverDto: TurnoverDto
}
export const ContainerHistoryRowActions = observer(({ turnoverDto }: Props) => {
  const { t } = useTranslate()
  const navigate = useNavigate()

  return (
    <OptionsButton
      tooltip={t('moreOptions', 'More options')}
      options={[
        {
          label: t('viewEvents', 'View events'),
          onClick: () => navigate(turnoverDto.Id!),
        },
      ]}
      position='right'
    />
  )
})
